import React from 'react';

import Helmet from './Helmet';

const Title = 'Okta SSO Integration | Canny';
const Description = 'Use Canny’s Okta SSO Integration to let your team securely sign in to Canny.';
const Image = 'https://canny.io/images/canny-social.png';

const OktaSSOLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/integrations/okta' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};
export default OktaSSOLandingHelmet;
